export function formatCpfCnpj(value: string | number): string {
    // Converte para string e remove tudo que não for dígito
    const digits = String(value).replace(/\D/g, "");

    if (digits.length === 11) {
        // Formatar CPF: 000.000.000-00
        return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (digits.length === 14) {
        // Formatar CNPJ: 00.000.000/0000-00
        return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    } else {
        // Retorna original se não for CPF nem CNPJ
        return digits;
    }
}
